export const COLOR_VARIANTS = {
  '#7AC555': 'bg-green_7AC555',
  '#760DDE': 'bg-purple_760DDE',
  '#FFA500': 'bg-orange_FFA500',
  '#76A5EA': 'bg-blue_76A5EA',
  '#E876EA': 'bg-pink_E876EA'
} as const;
